import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Input, Fieldset, RadioButtonsContainer, Legend, Label } from './RadioFieldSet.styles';

const RadioFieldSet = ({
  name,
  legend,
  radioButtons,
  selectedValue,
  onChange,
  noDefault,
  spaceBetween,
  direction,
  className,
  optionalChildren = {},
  CustomRadioField = null
}) => (
  <Fieldset>
    {legend && <Legend>{legend}</Legend>}
    <RadioButtonsContainer direction={direction} spaceBetween={spaceBetween} className={className}>
      {radioButtons.map(({ value, label, disabled }, index) =>
        CustomRadioField ? (
          <CustomRadioField
            key={value}
            name={name}
            value={value}
            disabled={disabled}
            label={label}
            radioButtons={radioButtons}
            selectedValue={selectedValue}
            onChange={onChange}
            noDefault={noDefault}
          />
        ) : (
          <Fragment key={value}>
            <Label htmlFor={`${name}-${value}`} spaceBetween={spaceBetween}>
              <Input
                type="radio"
                defaultChecked={!noDefault && index === 0}
                checked={(!noDefault && !selectedValue && value === radioButtons[0].value) || value === selectedValue}
                name={name}
                id={`${name}-${value}`}
                value={value}
                disabled={disabled}
                onChange={onChange}
              />
              {label}
            </Label>
            {optionalChildren[value] || null}
          </Fragment>
        )
      )}
    </RadioButtonsContainer>
  </Fieldset>
);

RadioFieldSet.propTypes = {
  legend: PropTypes.node,
  name: PropTypes.string.isRequired,
  direction: PropTypes.string,
  selectedValue: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  spaceBetween: PropTypes.bool,
  noDefault: PropTypes.bool,
  radioButtons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.string.isRequired,
      disabled: PropTypes.bool
    })
  ),
  optionalChildren: PropTypes.shape(),
  CustomRadioField: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null, undefined])])
};

RadioFieldSet.defaultProps = {
  direction: 'row'
};

export default RadioFieldSet;
